import React, { PropsWithChildren, ReactElement } from "react";
import styles from "./responsiveComponents.module.scss";

export const DisplayOnMobile = (props: PropsWithChildren): ReactElement => {
  return <div className={styles["mobileOnly"]}>{props.children}</div>;
};

export const DisplayOnDesktop = (
  props: PropsWithChildren<{ style?: any }>,
): ReactElement => {
  return (
    <div style={props.style} className={styles["desktopOnly"]}>
      {props.children}
    </div>
  );
};
